// src/components/atoms/SortButton/SortButton.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from '@mui/material';
import { Sort as SortIcon } from '@mui/icons-material';
import {
  operationalFontSizes,
  operationalRadii,
  operationalSizing,
  operationalSpacing
} from '../../../design-system/tokens';

/**
 * SortButton - Componente para botão de ordenação
 *
 * CLASSIFICAÇÃO: ÁTOMO (com ressalva)
 *
 * NOTA: Este componente combina Button + Tooltip, o que tecnicamente
 * o classificaria como MOLÉCULA no Atomic Design puro.
 * Mantido em atoms por compatibilidade, mas considerar migração futura.
 *
 * @see https://bradfrost.com/blog/post/atomic-web-design/
 */
const SortButton = ({
  onClick,
  tooltip = 'Ordenar',
  className = '',
  ...props
}) => {
  return (
    <Tooltip title={tooltip} arrow>
      <Button
        variant="outlined"
        onClick={onClick}
        className={`sort-button ${className}`}
        sx={{
          // Usando Design Tokens para consistência
          minWidth: operationalSizing.compact,
          height: operationalSizing.compact,
          px: operationalSpacing.md,
          py: operationalSpacing.xs,
          fontSize: operationalFontSizes.lg,
          borderRadius: `${operationalRadii.control}px`,
          ...props.sx
        }}
        {...props}
      >
        <SortIcon />
      </Button>
    </Tooltip>
  );
};

SortButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.string,
  className: PropTypes.string
};

export default SortButton;
